module.exports = __webpack_public_path__ + "static/img/Frame_4110@2x.6c82889.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Frame_4110@2x.png
// module id = 5lpD
// module chunks = 64